<template>
  <div class="instructor-layout">
    <header class="instructor-header">
      <div class="header-content">
        <div class="header-left">
          <h1 class="logo">👨‍🏫 オトエイゴ講師管理</h1>
        </div>
        <div class="header-right">
          <div class="user-info">
            <span class="user-display">{{ headerUserName }}</span>
          </div>
        </div>
      </div>
    </header>

    <main class="instructor-main">
      <slot />
    </main>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { supabase } from '../../supabaseClient'

const router = useRouter()
const headerUserName = ref('')

onMounted(async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) {
      router.push('/instructor/login')
      return
    }
    const { data: profile } = await supabase
      .from('users_phase2')
      .select('full_name, instructor_display_name')
      .eq('id', user.id)
      .single()
    const realName = (profile?.full_name || '').trim()
    const displayName = (profile?.instructor_display_name || '').trim()
    if (realName) {
      headerUserName.value = displayName ? `${realName}（${displayName}）さん` : `${realName}さん`
    } else {
      headerUserName.value = displayName ? `${displayName}さん` : user.email || '講師'
    }
  } catch (error) {
    console.error('ユーザー情報取得エラー:', error)
    router.push('/instructor/login')
  }
})

</script>

<style scoped>
.instructor-layout {
  min-height: 100vh;
  background: #f8fafc;
}

.instructor-header {
  background: white;
  border-bottom: 2px solid #e5e7eb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left .logo {
  margin: 0;
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 700;
}

.header-right .user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-display {
  color: #6b7280;
  font-size: 0.9rem;
  font-weight: 500;
}

.instructor-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
}

/* スマホ対応 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .header-left .logo {
    font-size: 1.3rem;
  }
  
  .user-info {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
